import { render } from "./DiscardPile.vue?vue&type=template&id=28030322&scoped=true"
import script from "./DiscardPile.vue?vue&type=script&lang=js"
export * from "./DiscardPile.vue?vue&type=script&lang=js"

import "./DiscardPile.vue?vue&type=style&index=0&id=28030322&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28030322"]])

export default __exports__